module.exports = __webpack_public_path__ + "static/media/CK.7754a94f.png";